import React, { useState } from 'react';
import { faqs } from '../../data/mockData';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiChevronDown } = FiIcons;

const AccordionItem = ({ faq, isOpen, onClick }) => {
  return (
    <div className="border-b border-luma-sand last:border-0">
      <button 
        className="w-full py-6 flex justify-between items-center text-left focus:outline-none"
        onClick={onClick}
      >
        <span className="font-serif text-xl pr-8">{faq.question}</span>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <SafeIcon icon={FiChevronDown} className="text-luma-primary text-xl" />
        </motion.div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <p className="pb-6 text-luma-text/70 leading-relaxed">
              {faq.answer}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 max-w-3xl mx-auto px-6">
      <div className="text-center mb-12">
        <h2 className="font-serif text-4xl mb-4">Questions & Care</h2>
        <p className="text-luma-text/70">Everything you need to know about preparing for baby.</p>
      </div>

      <div className="bg-white rounded-3xl p-8 shadow-sm border border-luma-sand/50">
        {faqs.map((faq, index) => (
          <AccordionItem 
            key={index} 
            faq={faq} 
            isOpen={openIndex === index}
            onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
          />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;